import { CLEAR_BUSINESS_CLINIC_LIST, GET_BUSINESS_CLINIC_LIST } from "../../constants/business-location-const/BusinessLocationConst";
import { GET_TREATMENTS_FOR_USER, SET_LAST_STEP } from "../../constants/treatment-list-const/TreatmentListConst";


const initialState = {
  businessClinicList: null,
  treatmentsForUser: [],
  deleteStatus: false,
  totalTreatments: 0,
  loadedTreatmentsCount: 0,
  clinicListPract: [],
  totalClinics: 0,
  loadedClinicsCount: 0,
  treatmentList: [],
  business_name: "",
  clinic_id: 0,
  clinicListPage: 0,

  isLastStep: false,
};

export default function businessLocationListReducer(state = initialState, action) {

  switch (action.type) {

    case GET_BUSINESS_CLINIC_LIST:

      // let page1 = action?.page
      // let tempLoadedClinics = action?.payload;
      // let tempTotalClinics = state?.loadedClinicsCount + tempLoadedClinics?.items?.length;

      // let clinicsUpdatedResponse;
      // if (page1 == 1) {
      //   clinicsUpdatedResponse = action?.payload
      // }
      // else {
      //   clinicsUpdatedResponse = [
      //     ...state.clinicListPract,
      //     ...action.payload?.items
      //   ]
      // }
      const temp = state?.businessClinicList?.items != undefined ?
        (state?.businessClinicList?.items).concat(action?.payload?.items) :
        action?.payload?.items
      const tempData = { 
        ...state?.businessClinicList, 
        ...action?.payload,
        items: temp 
      }
      return {
        ...state,
        // clinicListPract: clinicsUpdatedResponse,
        businessClinicList: tempData,
        totalClinics: action.payload.total,
        loadedClinicsCount: temp?.length,
        clinicListPage: state.clinicListPage + 1,
        business_name: action.payload?.company_name,
        clinic_id: action.payload?.clinic_id
      };
      break;



    case GET_TREATMENTS_FOR_USER:
      // let page = action?.page
      // let tempLoadedItems = action.payload.items;
      // let tempLoadedtotal = state.loadedTreatmentsCount + tempLoadedItems?.length;
      // let updatedResponse1

      // let categoriesArray = [];

      // tempLoadedItems.forEach(element => 
      //   element?.treatment_category.forEach((item)=>
      //   (!categoriesArray?.includes(item) && item != null) &&
      //     categoriesArray.push(item)
      //   )
      //   );
      // let newTreatmentList = categoriesArray.map((element)=>{
      //   let treatments = [];
      //   tempLoadedItems.forEach((item)=>
      //     item?.treatment_category?.includes(element) && treatments.push(item)
      //   )
      //   return(
      //     {
      //       categoryName : element,
      //       treatments : treatments
      //     }
      //   )
      // })


      // if (page == 1) {
      //   updatedResponse1 = action.payload.items
      // }
      // else {
      //   updatedResponse1 = [
      //     ...state.treatmentsForUser,
      //     ...action.payload.items
      //   ]
      // }
      // return {
      //   ...state,
      //   newTreatmentList: newTreatmentList,
      //   treatmentsForUser: updatedResponse1,
      //   totalTreatments: action.payload.total,
      //   loadedTreatmentsCount: tempLoadedtotal,
      // }

      return {
        ...state,
        treatmentList: action.payload,
      };

    // case DELETE_SELECTED_TREATMENTS:
    //   let selectedIds = action.payload;
    //   let updatedResponse = state.treatmentsForUser.filter((item) =>
    //     selectedIds.includes((item?.treatment_id)) != true
    //   )
    //   return {
    //     ...state,
    //     treatmentsForUser: updatedResponse,
    //   }

    // case DELETE_SELECTED_TREATMENTS_SUCCESS:
    //   return {
    //     ...state,
    //     deleteStatus: action.payload,
    //   }

    case SET_LAST_STEP:
      return {
        ...state,
        isLastStep: action.payload,
      }

    case CLEAR_BUSINESS_CLINIC_LIST:
      return {
        ...state,
        businessClinicList: null,
        clinic_id: 0,
        totalClinics: 0,
        loadedClinicsCount: 0,
        clinicListPage: 0,
      }


    default:
      return state;
  }



}
